export default __webpack_public_path__ + "static/Royal-Stamp-logo-e1bcb52654534567f314e7ea0ecc6e81.svg";